import { useCallback, useEffect } from 'react';

import ConsentService from './ConsentService';
import { Consent } from './constants';

export type ConsentCallback = (consent: Consent) => void;

const useConsentListener = (callback: ConsentCallback, shouldCallbackInitialValue = false) => {
  const handleConsentReady = useCallback(() => {
    callback(ConsentService.getConsent());
  }, [callback]);

  useEffect(() => {
    window.addEventListener('CookiebotOnConsentReady', handleConsentReady);

    return function cleanup() {
      window.removeEventListener('CookiebotOnConsentReady', handleConsentReady);
    };
  }, [handleConsentReady]);

  useEffect(() => {
    if (shouldCallbackInitialValue) {
      callback(ConsentService.getConsent());
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useConsentListener;
